module.exports = __webpack_public_path__ + "static/media/HCMM272.fca824ee.jpg";